import React from "react";
import TermsOfServiceView from "./TermsOfService.view";
import VoiceGainGitHubResourcesApi from "../../../../services/VoicegainGithubResources";
interface IState {
  termsOfServiceText?: string;
}

class TermsOfServiceContainer extends React.Component<any, IState> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }
  
  public render = () => (
    <TermsOfServiceView termsOfServiceText={this.state.termsOfServiceText} />
  );

  public componentDidMount = () => this.generateTermsOfServiceText();

private generateTermsOfServiceText = () => {
  VoiceGainGitHubResourcesApi.getTermsOfService()
    .then(response => response.text())
    .then(termsOfServiceText => this.setState({ termsOfServiceText }));
}  
}

export default TermsOfServiceContainer;
